import 'jquery.maskedinput/src/jquery.maskedinput'

$(function() {
  $('.time_format_mask').mask('99:99')
})
